import React from 'react'
import BudgetEditor from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import ModalFrameHoc from 'components/Modal/modalFrameHoc'

const BudgetEditorModal = (props) => {
  const { closeModal, title, meta } = props
  const { t } = useTranslation()

  return (
    <ModalFrameHoc
      {...props}
      closeModal={() => {
        meta.reject()
        closeModal()
      }}
      title={t(title)}
    >
      <BudgetEditor {...props} />
    </ModalFrameHoc>
  )
}

export default BudgetEditorModal

BudgetEditorModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  meta: PropTypes.object,
  ids: PropTypes.array,
  resource: PropTypes.string.isRequired,
}
